
export enum StorageLocationType {
    // Local,
    CloudUserFolder,
    CloudShareFolder,
    CloudEnterprise
}
